(() => {
  'use strict';

  const AUTO_ATTEMPT_KEY = 'comfi:auto-market-attempt';
  const MANUAL_CHOICE_KEY = 'comfi:manual-market-choice';
  const ROUTED_COUNTRIES = new Set(['GB', 'US']);

  if (window.Shopify && window.Shopify.designMode) return;

  const storage = {
    get(key) {
      try {
        return window.sessionStorage.getItem(key);
      } catch (_error) {
        return null;
      }
    },
    set(key, value) {
      try {
        window.sessionStorage.setItem(key, value);
      } catch (_error) {
        // Storage can be unavailable in strict privacy modes. The redirect still works.
      }
    },
  };

  function isLocalizationForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;

    return (
      form.matches('form[action$="/localization"], form.shopify-localization-form') ||
      Boolean(form.querySelector('[name="country_code"]'))
    );
  }

  // A customer's deliberate selector choice wins over GeoIP for this tab/session.
  document.addEventListener(
    'submit',
    (event) => {
      if (event.isTrusted && isLocalizationForm(event.target)) {
        storage.set(MANUAL_CHOICE_KEY, '1');
      }
    },
    true
  );

  // Dawn submits its selector with form.submit(), which skips the submit event.
  document.addEventListener(
    'click',
    (event) => {
      const option = event.target.closest('localization-form a[data-value]');
      const countryInput = option
        ?.closest('localization-form')
        ?.querySelector('input[name="country_code"]');

      if (event.isTrusted && option && countryInput) {
        storage.set(MANUAL_CHOICE_KEY, '1');
      }
    },
    true
  );

  const currentUrl = new URL(window.location.href);

  // Useful for testing and for country deep links used in ads or support messages.
  if (currentUrl.searchParams.has('country')) {
    storage.set(MANUAL_CHOICE_KEY, '1');
    return;
  }

  if (
    currentUrl.searchParams.get('no_redirect') === '1' ||
    currentUrl.searchParams.get('no_auto_localization') === '1'
  ) {
    storage.set(MANUAL_CHOICE_KEY, '1');
    return;
  }

  if (storage.get(MANUAL_CHOICE_KEY) === '1') return;

  const currentCountry = String(window.Shopify && window.Shopify.country ? window.Shopify.country : '').toUpperCase();
  const routesRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  const suggestionsUrl = new URL(`${routesRoot}browsing_context_suggestions.json`, window.location.origin);

  suggestionsUrl.searchParams.set('country[enabled]', 'true');
  if (currentCountry) suggestionsUrl.searchParams.set('country[exclude]', currentCountry);

  function updateCountry(countryCode) {
    const cleanReturnUrl = new URL(window.location.href);
    cleanReturnUrl.searchParams.delete('country');
    cleanReturnUrl.searchParams.delete('no_redirect');
    cleanReturnUrl.searchParams.delete('no_auto_localization');

    const form = document.createElement('form');
    form.method = 'POST';
    form.action = '/localization';
    form.hidden = true;

    const fields = {
      _method: 'PUT',
      country_code: countryCode,
      return_to: `${cleanReturnUrl.pathname}${cleanReturnUrl.search}${cleanReturnUrl.hash}`,
    };

    Object.entries(fields).forEach(([name, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  }

  fetch(suggestionsUrl.toString(), {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
  })
    .then((response) => {
      if (!response.ok) throw new Error(`Localization lookup failed (${response.status})`);
      return response.json();
    })
    .then((data) => {
      const countrySuggestion = data.suggestions
        ?.map((suggestion) => suggestion.parts?.country)
        .find(Boolean);
      const targetCountry = String(countrySuggestion?.handle || '').toUpperCase();

      // This store's page routing has explicit UK and US product pairs only.
      if (!ROUTED_COUNTRIES.has(targetCountry) || targetCountry === currentCountry) return;
      if (countrySuggestion.options && !countrySuggestion.options[targetCountry]) return;

      const attemptId = `${currentCountry || 'unknown'}:${targetCountry}`;
      if (storage.get(AUTO_ATTEMPT_KEY) === attemptId) return;

      // Write before submitting so an unavailable market can never cause a reload loop.
      storage.set(AUTO_ATTEMPT_KEY, attemptId);
      updateCountry(targetCountry);
    })
    .catch(() => {
      // Shopify's native automatic redirection remains the primary path. If this
      // optional fallback is unavailable, leave the current storefront untouched.
    });
})();
